import minesBombImage from '@/shared/assets/images/mines-bomb.png';
import rouletteWheelImage from '@/shared/assets/images/roulette-wheel.png';
import { ROUTES } from '@/shared/config/constants';

export type GameConfig = {
  id: string;
  route: string;
  title: string;
  subtitle: string;
  badge: string;
  badgeColor: string;
  accent: string;
  accentAlt: string;
  delay: number;
  disabled: boolean;
  image?: string;
};

export const GAME_ID_TO_WS_KEY: Record<string, string> = {
  roulette: 'roulette',
  jetton: 'jetton',
  mines: 'mines',
  balloon: 'balloon',
};

export const GAMES: GameConfig[] = [
  {
    id: 'roulette',
    route: ROUTES.ROLLS,
    title: 'Pure Rolls',
    subtitle: 'PVP Roulette',
    badge: 'LIVE',
    badgeColor: 'green',
    accent: '#8b5cf6',
    accentAlt: '#7c3aed',
    delay: 0,
    disabled: false,
    image: rouletteWheelImage,
  },
  {
    id: 'jetton',
    route: ROUTES.JETTON,
    title: 'JetTON',
    subtitle: 'Pump & Dump',
    badge: 'HOT',
    badgeColor: 'amber',
    accent: '#406aff',
    accentAlt: '#3357d0',
    delay: 0.08,
    disabled: false,
  },
  {
    id: 'mines',
    route: ROUTES.MINES,
    title: 'Mines',
    subtitle: 'Avoid the Mines',
    badge: 'NEW',
    badgeColor: 'green',
    accent: '#FBBF24',
    accentAlt: '#D97706',
    delay: 0.16,
    disabled: false,
    image: minesBombImage,
  },
  {
    id: 'balloon',
    route: ROUTES.BALLOON,
    title: 'Balloon',
    subtitle: 'Pump or Pop',
    badge: 'NEW',
    badgeColor: 'amber',
    accent: '#f472b6',
    accentAlt: '#db2777',
    delay: 0.24,
    disabled: false,
  },
];
